import React from 'react';
import { DH } from '../../../../utils/DataHook';
import { ICard } from '../../../../types/Card';
import { isExpired } from '../../../../utils/expirationUtils';
import { CardDetails } from '../../elements/CardDetails';
import { CardDetailsWrapper } from '../../elements/CardDetailsWrapper';
import { MarkCardPrimary } from '../../elements/MarkCardPrimary';
import { ActionButtons } from '../../elements/ActionButtons';
import { Overlay } from '../../elements/Overlay';
import { BackButton, CardRowContainer, CardRow } from '.';

interface ICardViewExpandedProps {
  expandedCard: ICard;
  collapseCard: () => void;
  isRemovingInProcess: boolean;
  showRemoveConfirmation: boolean;
  rtl: boolean;
}

interface ICardViewCollapsedProps {
  cards: ICard[];
  expandCard: (cardId: string) => void;
  rtl: boolean;
}

export const CardViewExpanded: React.FC<ICardViewExpandedProps> = (props) => (
  <CardDetailsWrapper>
    <BackButton onClick={props.collapseCard} rtl={props.rtl} />
    <CardRow
      card={props.expandedCard}
      isExpanded
      isExpired={isExpired(props.expandedCard.expiration)}
      rtl={props.rtl}
    />
    <MarkCardPrimary
      cardId={props.expandedCard.creditCardId}
      isExpired={isExpired(props.expandedCard.expiration)}
      primary={props.expandedCard.primary}
      rtl={props.rtl}
    />
    <CardDetails mobile {...props.expandedCard} />
    <ActionButtons />
    {(props.isRemovingInProcess || props.showRemoveConfirmation) && <Overlay mobile center loading />}
  </CardDetailsWrapper>
);
CardViewExpanded.displayName = 'CardViewExpanded';

export const CardViewCollapsed: React.FC<ICardViewCollapsedProps> = (props) => {
  return (
    <>
      {props.cards.map((card, idx) => (
        <CardRowContainer
          dataHook={DH.CardRow.ContainerBase(card.creditCardId)}
          key={idx}
          onClick={() => props.expandCard(card.creditCardId)}
        >
          <CardRow card={card} isExpired={isExpired(card.expiration)} rtl={props.rtl} />
          <MarkCardPrimary
            cardId={card.creditCardId}
            isExpired={isExpired(card.expiration)}
            primary={card.primary}
            rtl={props.rtl}
          />
        </CardRowContainer>
      ))}
    </>
  );
};
CardViewCollapsed.displayName = 'CardViewCollapsed';
